import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('BRAND SERVICE');

@Injectable({
  providedIn: 'root'
})
export class BrandsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'brands' como el nombre del recurso a la clase base
    super('brands');
    log.debug('Servicio de Marcas inicializado');
  }

}